const mobileCheck = function () {
  return window.innerWidth <= 768;
}; 

// Stockist (83 KB) was injected on every page, including the homepage, which has no
// store-locator widget to mount. Load it only where a mount point actually exists.
(function loadStockistIfNeeded() {
  if (!document.querySelector('[class*="stockist"], [id*="stockist"], [data-stockist]')) return;
  var s = document.createElement('script');
  s.src = '//stockist.co/embed/v1/widget.min.js';
  s.async = 1;
  document.head.appendChild(s);
})();

// Fancybox (39 KB JS + 6 KB CSS from jsDelivr) loaded on every page but is only used
// on product pages and three content pages. Pull it in on demand, driven by the page's
// own markup so there is no template list to keep in sync.
(function loadFancyboxIfNeeded() {
  if (!document.querySelector('[data-fancybox]')) return;

  var css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = '//cdn.jsdelivr.net/npm/@fancyapps/ui@6.0/dist/fancybox/fancybox.css';
  document.head.appendChild(css);

  var js = document.createElement('script');
  js.src = '//cdn.jsdelivr.net/npm/@fancyapps/ui@6.0/dist/fancybox/fancybox.umd.js';
  js.onload = function () {
    if (typeof Fancybox !== 'undefined') Fancybox.bind('[data-fancybox]');
  };
  document.head.appendChild(js);
})();


function updateCartCountBubble(count) {
  const bubble = document.querySelector('.cart-count-bubble');
  if (!bubble) return;

  const spans = bubble.querySelectorAll('span');
  spans.forEach(span => span.textContent = count);

  // bubble.style.display = count > 0 ? '' : 'none';
}

document.addEventListener('rebuy:cart.ready', (event) => {
  updateCartCountBubble(event.detail.cart.cart.item_count);
});

document.addEventListener('rebuy:cart.change', (event) => {
  updateCartCountBubble(event.detail.cart.cart.item_count);
});